export enum EmployerContactSubmissionChangeTypeEnum {
  Neutral = 1,
  New = 2,
  Previous = 3
}
